module.exports = __webpack_public_path__ + "img/sendcloud.2ae080b2.jpg";